import { eventTable, organizationsTable } from '~/db/schema';
import { OrgCard } from './OrganizationPage/OrgCard';
import { OrgEvent } from './OrganizationPage/OrgEvent';
import { Page } from './Page';

interface OrganizationPageProps {
  organization: typeof organizationsTable.$inferSelect & {
    events?: Array<typeof eventTable.$inferSelect>;
  };
  hasCustomDomain: boolean;
}

export function OrganizationPage({
  organization,
  hasCustomDomain,
}: OrganizationPageProps) {
  if (!organization.events || organization.events.length === 0) {
    return (
      <Page>
        <div className="flex flex-1 w-full justify-center items-center px-4 md:pt-4">
          <OrgCard organizationName={organization.name} hasNoEvents>
            <div>No upcoming events</div>
          </OrgCard>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <div className="flex w-full justify-center px-4 md:pt-4">
        <OrgCard organizationName={organization.name}>
          {organization.events.map((event) => {
            return (
              <OrgEvent
                key={event.id}
                orgSlug={organization.slug}
                eventSlug={event.slug}
                event={event}
                hasCustomDomain={hasCustomDomain}
              />
            );
          })}
        </OrgCard>
      </div>
    </Page>
  );
}
